import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { useI18n } from "../i18n/I18nProvider";
import { EmptyState } from "../components/ui/EmptyState";
import { Input } from "../components/ui/Input";
import { PageHeader } from "../components/ui/PageHeader";
import { DenseTable, QueryError, TD_CLASS, TH_CLASS } from "./dense";
import { adminErrorsQuery } from "./queries";
import { errorRoute, formatDateTime } from "./format";

/** Recent API errors, optionally narrowed to one workspace. */
export function ErrorsPage() {
  const { t } = useI18n();
  const [workspaceId, setWorkspaceId] = useState("");
  const trimmed = workspaceId.trim() || undefined;
  const errors = useQuery(adminErrorsQuery(trimmed));

  return (
    <div className="space-y-5">
      <PageHeader title={t("admin.errors.title")} />
      <Input
        aria-label={t("admin.errors.filter.workspace")}
        placeholder={t("admin.errors.filter.workspace")}
        value={workspaceId}
        onChange={(event) => setWorkspaceId(event.target.value)}
        className="md:max-w-80"
      />
      {errors.isError ? (
        <QueryError error={errors.error} onRetry={() => void errors.refetch()} />
      ) : null}
      {errors.isPending ? <p className="text-operate text-ink-3">{t("app.loading")}</p> : null}
      {errors.data && errors.data.length === 0 ? <EmptyState>{t("admin.empty")}</EmptyState> : null}

      {errors.data && errors.data.length > 0 ? (
        <DenseTable label={t("admin.errors.title")} scroll>
          <thead>
            <tr>
              <th scope="col" className={TH_CLASS}>
                {t("admin.col.time")}
              </th>
              <th scope="col" className={`${TH_CLASS} hidden md:table-cell`}>
                {t("admin.col.workspace")}
              </th>
              <th scope="col" className={TH_CLASS}>
                {t("admin.col.route")}
              </th>
              <th scope="col" className={`${TH_CLASS} hidden md:table-cell`}>
                {t("admin.col.level")}
              </th>
              <th scope="col" className={TH_CLASS}>
                {t("admin.col.message")}
              </th>
            </tr>
          </thead>
          <tbody>
            {errors.data.map((entry) => (
              <tr key={entry.id} className="align-top hover:bg-blue-wash/40">
                <td className={`${TD_CLASS} text-note tabular-nums whitespace-nowrap text-ink-2`}>
                  {formatDateTime(entry.at)}
                </td>
                <td className={`${TD_CLASS} hidden text-note text-ink-2 md:table-cell`}>
                  {entry.workspaceId ?? t("common.none")}
                </td>
                <td className={`${TD_CLASS} font-mono text-note`}>
                  {errorRoute(entry.metaJson) ?? t("common.none")}
                </td>
                <td className={`${TD_CLASS} hidden font-mono text-note md:table-cell`}>
                  {entry.level}
                </td>
                <td className={TD_CLASS}>{entry.message}</td>
              </tr>
            ))}
          </tbody>
        </DenseTable>
      ) : null}
    </div>
  );
}
